<div id="complaint-list" class="page-layout carded fullwidth inner-scroll">

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="main-header mb-4" fxLayout="row wrap" fxLayoutAlign="flex-start center">
            <div class="pl-8" fxLayout="row wrap" > <!-- fxLayout="row" fxLayoutAlign="space-between center"-->
                <div fxLayout="row" fxLayoutAlign="space-between center">
                    <!--ADD-->
                    <button fxFlex="0 1 200px" color="accent" mat-raised-button 
                        class="m-12 p-4 massive-action" matTooltip="{{'GRID.FILTERS.ADD' | translate}}"
                        matTooltipPosition="above" [routerLink]="'/cases/create-case'" *ngIf="addManualButton">
                        <span class="">{{'GRID.FILTERS.ADD' | translate}}</span>
                    </button>

                    <button fxFlex="0 1 400px" color="accent" mat-raised-button (click)="generateReport()"
                        class="m-12 p-4 massive-action" matTooltip="{{'COMMON_LIST.ACTIONS.REPORTS' | translate}}"
                        matTooltipPosition="above" [disabled]="selectedList.length < 1" *ngIf="canGenerateReport">
                        <span class="">{{'COMMON_LIST.ACTIONS.REPORTS' | translate}}</span>
                    </button>
                </div>
            </div>
            <div fxFlex="1 1 auto" fxLayout="row wrap" fxLayoutAlign="flex-end center">
                <button fxFlex="0 1 auto" mat-icon-button color="accent" (click)="loadData()">
                    <mat-icon>refresh</mat-icon>
                </button>
                <!--PAGINATOR-->
                <mat-paginator #paginator [length]="tableCountSubject | async" [pageIndex]="0" [pageSize]="10"
                    [pageSizeOptions]="[1, 5, 10, 25, 100]">
                </mat-paginator>
    
                <div fxFlex="0 1 auto" fxLayout="row" class="btns-control">
                    <!--TOGGLE VIEW-->
                    <button mat-mini-fab class="mr-8" color="accent" (click)="toggleView()"fxHide.xs fxHide.sm
                        matTooltip="{{(toggleIsTicketsTableView? 'GRID.TABLE.ACTION.TOGGLE-TO-CARD' : 'GRID.TABLE.ACTION.TOGGLE-TO-TABLE') | translate}}"
                        matTooltipPosition="above">
                        <div class="" fxLayout="row wrap" fxLayoutAlign="center flex-end">
                            <mat-icon class="font-size-16">{{toggleIsTicketsTableView? 'border_all' : 'dns'}}
                            </mat-icon>
                        </div>
                    </button>
    
                    <!--SORTING-->
                    <button mat-mini-fab [matMenuTriggerFor]="sortingMenu" class="mr-8" color="accent"
                        matTooltip="{{'GRID.FILTERS.SORTING' | translate}}" matTooltipPosition="above">
                        <div class="" fxLayout="row wrap" fxLayoutAlign="center flex-end">
                            <mat-icon class="font-size-16">import_export</mat-icon>
                        </div>
                    </button>
    
                    <mat-menu #sortingMenu="matMenu" [overlapTrigger]="false">
    
                        <button mat-menu-item *ngFor="let sorting of sortings" (click)="setSortingBy(sorting)"
                            color="accent">
                            <span fxLayout="row" fxLayoutAlign="start center">
                                <span class="iso">
                                    {{'CASES.'+sorting.replace('.','_').toUpperCase() | translate}}
                                </span>
                                <mat-icon *ngIf="sortBy == sorting" fxFlex="100%" color="accent" class="ml-8">done
                                </mat-icon>
                            </span>
                        </button>
                        <mat-divider></mat-divider>
                        <button mat-menu-item (click)="setSortingOrder('asc')">
                            <span fxLayout="row" fxLayoutAlign="start center">
                                <span class="iso">
                                    {{'GRID.FILTERS.ASC' | translate}}
                                </span>
                                <mat-icon *ngIf="sortOrder == 'asc'" fxFlex="100%" color="accent" class="ml-8">done
                                </mat-icon>
                            </span>
                        </button>
                        <button mat-menu-item (click)="setSortingOrder('desc')">
                            <span fxLayout="row" fxLayoutAlign="start center">
                                <span class="iso">
                                    {{'GRID.FILTERS.DESC' | translate}}
                                </span>
                                <mat-icon *ngIf="sortOrder == 'desc'" fxFlex="100%" color="accent" class="ml-8">done
                                </mat-icon>
                            </span>
                        </button>
    
                    </mat-menu>
    
                    <!--FILTERS TOGGLE-->
                    <button color="accent" mat-mini-fab (click)="toggleFilterSideNav()" class="mr-8"
                        matTooltip="{{'GRID.FILTERS.TOGLE' | translate}}" matTooltipPosition="above">
                        <mat-icon class="font-size-16">filter_list</mat-icon>
                    </button>

                    <!--DYNAMIC FILTERS-->
                    <button color="accent" mat-mini-fab (click)="openDynamicFilters()"  class="mr-8" fxHide.xs
                        matTooltip="{{'GRID.FILTERS.DYNAMIC_FILTERS' | translate}}" matTooltipPosition="above" *ngIf="btnDynamicFilters"><!---->
                        <mat-icon class="font-size-16">tune</mat-icon>
                    </button>
                </div>
            </div>
        </div>

         <!-- DRAWER CONTAINER -->
         <mat-sidenav-container>

            <mat-sidenav-content>
                <mat-sidenav-container>
                    <mat-sidenav-content>
                        <!-- CONTENT CARD -->
                        <div class="content-card">
                            <!--CARD-CONTAINER-->
                            <div [ngStyle]="{'display': toggleIsTicketsTableView ? 'none' : 'flex'}">
                                <div class="ticket-list-container" fxLayout="row wrap">

                                    <!--CARD-->
                                    <div fxFlex="100%" class="ticket-card m-8 p-8" fxLayout="row"
                                        fxLayoutAlign="flex-start center" *ngFor="let item of dataSource.data">
                                        
                                        <div fxFlex="45" fxLayout="row wrap" fxLayoutAlign="flex-start center">
                                            <div fxFlex="100%" class="pl-8" fxLayoutAlign="flex-start center">
                                                <mat-checkbox class="example-margin" [checked]="item.selected" (change)="itemCheck(item, $event)">
                                                </mat-checkbox>
                                            </div>
                                            <div fxFlex="100%" fxLayout="row" fxLayoutAlign="flex-start center" class="mb-8">
                                                <mat-icon class="mr-4" matTooltip="{{'CASES.TITLE' | translate}}"
                                                    matTooltipPosition="above">tag</mat-icon>
                                                <span>{{item.title}}</span>
                                            </div>
                                            <div fxFlex="100%" fxLayout="row" fxLayoutAlign="flex-start center" class="mb-8">
                                                <mat-icon class="mr-4" matTooltip="{{'CASES.CASE_TYPE' | translate}}"
                                                    matTooltipPosition="above">extension</mat-icon>
                                                <span>{{item.caseTypeDescription}}</span>
                                            </div>
                                            <div fxFlex="100%" fxLayout="row" fxLayoutAlign="flex-start center" class="mb-8">
                                                <mat-icon class="mr-4" matTooltip="{{'ALERTS.FIELDS.CREATEDDATE' | translate}}"
                                                    matTooltipPosition="above">event</mat-icon>
                                                <span>{{item.creationDate ? item.creationDate : item.createdDate | date:'yyyy-MM-dd'}}</span>
                                            </div>
                                        </div>

                                        <div fxFlex="45" fxLayout="row wrap" fxLayoutAlign="flex-start center">
                                            <div fxFlex="100%" fxLayout="row" fxLayoutAlign="flex-start center" class="mb-8">
                                                <mat-icon class="mr-4" matTooltip="{{'ALERTS.FIELDS.RESOLUTION_DESCRIPTION' | translate}}"
                                                    matTooltipPosition="above">notes</mat-icon>
                                                <span>{{item.resolutionDescription && ("ALERTS.MASSIVE_ACTIONS." + item.resolutionDescription) | translate}}</span>
                                            </div>
                                            <div fxFlex="100%" fxLayout="row" fxLayoutAlign="flex-start center" class="mb-8">
                                                <mat-icon class="mr-4" matTooltip="{{'CASES.WORKFLOW_CURRENT_STEP' | translate}}"
                                                    matTooltipPosition="above">description</mat-icon>
                                                <span>{{item.currentWorkflowStepDescription}}</span>
                                            </div>
                                            <div fxFlex="100%" fxLayout="row" fxLayoutAlign="flex-start center" class="mb-8">
                                                <mat-icon class="mr-4" matTooltip="{{'ALERTS.FIELDS.MODIFIEDDATE' | translate}}"
                                                    matTooltipPosition="above">edit_calendar</mat-icon>
                                                <span>{{item.modifiedDate | date:'yyyy-MM-dd'}}</span>
                                            </div>
                                            <div fxFlex="100%" fxLayout="row" fxLayoutAlign="flex-start center">
                                                <mat-icon class="mr-4"
                                                    matTooltip="{{'ALERTS.FIELDS.STATUS_DESCRIPTION' | translate}}"
                                                    matTooltipPosition="above">traffic</mat-icon>
                                                <span>{{ ("CASES.STATUS." + item.statusDescription) | translate }}</span>
                                            </div>
                                        </div>

                                        <div fxFlex="10">
                                            <app-case-actions  [id]="item.id" [statusId]="item.statusId" [workflowInstanceId]="item.workflowInstanceId" (action)="listActions($event)">
                                            </app-case-actions>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <!--/CARD-CONTAINER-->

                            <!--TABLE-->
                            <div [ngStyle]="{'display': toggleIsTicketsTableView? 'flex' : 'none'}">
                                <div class="ticket-table-container" fxLayout="row">
                                    <mat-table class="ticket-table" #table [dataSource]="dataSource" matSort
                                        [matSortActive]="sortBy" [matSortStart]="sortOrder"
                                        (matSortChange)="setMatSorting($event)" [@animateStagger]="{value:'50'}">

                                        <ng-container matColumnDef="SELECT">
                                            <mat-header-cell *matHeaderCellDef>
                                                <mat-checkbox class="example-margin" style="margin: 0 auto" [checked]="allChecked" [matTooltip]="'COMMON_LIST.SELECT' | translate" (change)="checkAll($event)">
                                                </mat-checkbox>
                                            </mat-header-cell>
                                            <mat-cell fxLayoutAlign="center center" *matCellDef="let item">
                                                <mat-checkbox class="example-margin" [checked]="item.selected" (change)="itemCheck(item, $event)">
                                                </mat-checkbox>
                                            </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="TITLE">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header>
                                                {{'CASES.TITLE' | translate}}
                                            </mat-header-cell>
                                            <mat-cell *matCellDef="let item">
                                                <p> {{item.title }}</p>
                                            </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="WorkflowInstance.CurrentStep.WorkflowStep.Title">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header>
                                                {{'CASES.WORKFLOW_CURRENT_STEP' | translate}}
                                            </mat-header-cell>
                                            <mat-cell fxLayoutAlign="center center" *matCellDef="let item">
                                                <p class="text-truncate">
                                                    {{item.currentWorkflowStepDescription}}</p>
                                            </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="Type.Description">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header>
                                                {{'CASES.CASE_TYPE' | translate}}
                                            </mat-header-cell>
                                            <mat-cell fxLayoutAlign="center center" *matCellDef="let item">
                                                <p class="text-truncate">
                                                    {{item.caseTypeDescription}}</p>
                                            </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="CREATEDDATE">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header>
                                                {{'ALERTS.FIELDS.CREATEDDATE' | translate}}
                                            </mat-header-cell>
                                            <mat-cell fxLayoutAlign="center center" *matCellDef="let item">
                                                <p class="text-truncate">
                                                    {{item.creationDate ? item.creationDate : item.createdDate | date:'yyyy-MM-dd'}}</p>
                                            </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="Status.Description">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header>
                                                {{'ALERTS.FIELDS.STATUS_DESCRIPTION' | translate}}
                                            </mat-header-cell>
                                            <mat-cell fxLayoutAlign="center center" *matCellDef="let item">
                                                <p class="text-truncate">
                                                    {{("CASES.STATUS." + item.statusDescription) | translate }}</p>
                                            </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="MODIFIEDDATE">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header>
                                                {{'ALERTS.FIELDS.MODIFIEDDATE' | translate}}
                                            </mat-header-cell>
                                            <mat-cell fxLayoutAlign="center center" *matCellDef="let item">
                                                <p class="text-truncate">
                                                    {{item.modifiedDate | date:'yyyy-MM-dd'}}</p>
                                            </mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="ACTIONS" stickyEnd >
                                            <mat-header-cell *matHeaderCellDef class="cell150-w"></mat-header-cell>
                                            <mat-cell class="cell150-w" *matCellDef="let item" fxLayout="row"
                                                fxLayoutAlign="start center" style="border-left: 1px solid rgba(128, 128, 128, 0.26);">
                                                <app-case-actions  [id]="item.id" [statusId]="item.statusId" (action)="listActions($event)">
                                                </app-case-actions>
                                            </mat-cell>
                                        </ng-container>

                                        <mat-header-row *matHeaderRowDef="displayedColumns;"></mat-header-row>

                                        <mat-row *matRowDef="let item; columns: displayedColumns;" class="ticket"
                                            [class.user-pointer]="false" matRipple>
                                        </mat-row>

                                    </mat-table>

                                    <!-- GRID LOADER -->
                                    <div *ngIf="loadingDataSource"
                                        style="max-height: 30px; position: absolute; left: 50%; top: 50%; transform: translate(-50%,-50%);">
                                        <mat-progress-spinner [diameter]="40" color="primary" mode="indeterminate">
                                        </mat-progress-spinner>
                                    </div>
                                    <!-- / GRID LOADER -->
                                </div>
                            </div>

                            <!--/TABLE-->
                        </div>
                        <!-- / CONTENT CARD -->
                    </mat-sidenav-content>
                    <mat-sidenav #dynamicFilterSidenav mode="over" position="end" [opened]="toggleIsFDynacimFilterPanelOpen"
                        [ngClass]="panelExpanded ? 'dynamic-filter-transform' : 'dynamic-filter-reverse-transform'">
                            <div class="p-8" fxLayout="row wrap">
                                <button mat-mini-fab class="mt-8" color="accent" 
                                matTooltip="{{(!panelExpanded ? 'GRID.TABLE.ACTION.EXPAND-PANEL' : 'GRID.TABLE.ACTION.REDUCE-PANEL') | translate}}"
                                matTooltipPosition="above" (click)="panelExpanded = !panelExpanded">
                                    <div class="" fxLayout="row wrap" fxLayoutAlign="center flex-end">
                                        <mat-icon class="font-size-16" *ngIf="!panelExpanded">west</mat-icon>
                                        <mat-icon class="font-size-16" *ngIf="panelExpanded">east</mat-icon>
                                    </div>
                                </button>
                                <div fxFlex="90%">
                                    <app-dynamic-filters fxFlex="100%"
                                        [moduleSelectData]="moduleSelectData" [entityModule]="currentModuleSelected" 
                                        [usePreviousData]="dynamicFiltersApplied" [prevFilters]="dynamicCaseFilters"
                                        [currentWorkflowSelected]="currentWorkflowSelected" [filtersLabel]="'NAV.CASES'"
                                        [loadingSearch]="loadingSearch" [selectStepLabel]="'WORKFLOW.SELECT_STEP'"
                                        [currentStepSelected]="currentFilterStepSelected" [workflowTypeByModule]="workflowTypeByModule"
                                        (onModuleSelected)="onModuleSelected($event)" (stepFiltered)="handleApplyFilters($event)"
                                        (onClearFilters)="onClearFilters($event)" (onWorflowSelected)="onWorflowSelected($event)"
                                        (onStepSelected)="onStepSelected($event)" (onClearAllFilters)="onClearAllFilters($event)">
                                    </app-dynamic-filters>
                                </div>
                                <!-- <div style="width: 100%; display: flex; justify-content: space-around">
                                    <mat-spinner [diameter]="40" *ngIf="dynamicFilterComponentLoading"></mat-spinner>
                                </div> -->
                            </div>
                    </mat-sidenav>
                </mat-sidenav-container>
            </mat-sidenav-content>

            <mat-sidenav #sidenav mode="over" position="end" [opened]="toggleIsFilterPanelOpen"
                [ngStyle.xs]="{'max-width': '100%'}" [ngStyle.sm]="{'max-width': '100%'}">
                <!--FILTERS SIDENAV-->
                <app-case-advanced-filters [searchFormCases]="searchForm" [searchFormAlert]="searchFormAlert"
                  [statusData]="statusData" [caseTypes]="caseTypes"  [modules]="modulesAdvancedFilter"
                  [criticalitiesData]="criticalitiesData" [sourcesData]="sourcesData" (setFilters)="handleAdvancedFilters($event)"
                  [currentModule]="filtersCurrentModule" [progressBar]="fuseProggressBarService.visible | async"></app-case-advanced-filters>
                 <!-- -->

                <!-- <form [formGroup]="searchForm" fxLayout="row wrap" class="p-12 pb-56">
                    
                    <span fxFlex="1 1 100%" class="mb-20"><strong>{{'GRID.FILTERS.ADVANCED' |
                        translate}}</strong></span>

                    <div fxLayout="column" fxFlex="100%" class="mb-12">
                        <mat-label> {{ 'CASES.CASE_TITLE' | translate }}</mat-label>
                        <mat-form-field fxFlex="100%" appearance="outline">
                            <input matInput formControlName="title" autocomplete="off"
                                [maxlength]="textFiltersMaxLength">
                        </mat-form-field>
                    </div> -->

                    <!-- STATUS_DESCRIPTION DROPDOWN -->
                    <!-- <mat-label fxFlex="100">{{'ALERTS.FIELDS.STATUS_DESCRIPTION' | translate}}
                    </mat-label>
                    <mat-form-field appearance="outline" floatLabel="always" class="mb-12" fxFlex="100%" color="accent">
                        <mat-select formControlName="status" placeholder="{{'PLACEHOLDER.ALL' | translate}}">
                            <mat-option>{{'PLACEHOLDER.ALL' | translate}}
                            </mat-option>
                            <mat-option *ngFor="let item of statusData" [value]="item.id.toString()">
                                {{ "CASES.STATUS." + item.description | translate}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field> -->

                    
                    <!-- RESOLUTION_DESCRIPTION DROPDOWN -->
                    <!-- <mat-label fxFlex="100">{{'CASES.CASE_TYPE' | translate}}
                    </mat-label>
                    <mat-form-field appearance="outline" floatLabel="always" class="mb-12" fxFlex="100%" color="accent">
                        <mat-select formControlName="caseType" placeholder="{{'PLACEHOLDER.ALL' | translate}}">
                            <mat-option>{{'PLACEHOLDER.ALL' | translate}}
                            </mat-option>
                            <mat-option *ngFor="let item of caseTypes" [value]="item.id.toString()">
                                {{ "CASES.TYPES." + item.description | translate}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <app-date-range-filter [form]="searchForm" fromControlName="dateFrom" toControlName="dateTo"
                    fromKeyLabel="COMMON_LIST.FILTERS.CREATED_DATE_FROM"
                    toKeyLabel="COMMON_LIST.FILTERS.CREATED_DATE_TO"></app-date-range-filter>
                                            
                    <app-date-range-filter [form]="searchForm" fromControlName="modifiedDateFrom"
                    toControlName="modifiedDateTo" fromKeyLabel="ALERTS.FILTERS.MODIFIED_FROM"
                    toKeyLabel="ALERTS.FILTERS.MODIFIED_TO"></app-date-range-filter> -->

                <!-- </form> -->

                <!--APPLY FILTERS BUTTON-->
                <!-- <mat-card fxLayout="row" class="aply-filters-button">
                    <button fxFlex="50" color="accent" mat-raised-button (click)="aplyFilters()"
                        [disabled]="searchForm.invalid" class="mx-8"
                        matTooltip=" {{'COMMON_LIST.ACTIONS.APPLY' | translate}}" matTooltipPosition="above">
                        {{'COMMON_LIST.ACTIONS.APPLY' | translate}}
                    </button>
                    <button fxFlex="40" color="primary" mat-raised-button (click)="clearFilters()" class="mx-8"
                        matTooltip=" {{'COMMON_LIST.ACTIONS.CLEAR' | translate}}" matTooltipPosition="above">
                        {{'COMMON_LIST.ACTIONS.CLEAR' | translate}}
                    </button>
                </mat-card> -->

            </mat-sidenav>
        </mat-sidenav-container>
    </div>
</div>